import App from './App.vue';

export default {
  path: '/CDS_VF_StaffList',
  name: 'CDS_VF_StaffList',
  component: App,
  meta: {
    pageProperty: {
      title: '参集人員報告',
      controller: 'CDS_CTR_StaffList',
    },
  },
};
